/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
*/

import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';

/**
 * Component for our aero-accordion.
 */
@Component({
  selector: 'aero-accordion',
  templateUrl: './aero-accordion.component.html',
  standalone: false,
})
export class AeroAccordionComponent {

  /**
   * Expose the value input so the section component can bind [value].
   */
  @Input() value: any;

  /**
   * Expose the valueChange output so the section component can listen to (valueChange).
   */
  @Output() valueChange = new EventEmitter<any>();

  /**
   * Default Constructor.
   */
  constructor() {}
}
